/** Phase 7C / Wave 1 B04 — SCR-BIZ-009–012 employees bindings (07-02) */

export const EMPLOYEES_SCREEN_IDS = [
  'SCR-BIZ-009',
  'SCR-BIZ-010',
  'SCR-BIZ-011',
  'SCR-BIZ-012',
] as const;

export type EmployeesScreenId = (typeof EMPLOYEES_SCREEN_IDS)[number];

export const EMPLOYEES_ROUTES: Record<EmployeesScreenId, string> = {
  'SCR-BIZ-009': '/employee-list',
  'SCR-BIZ-010': '/invite-employees',
  'SCR-BIZ-011': '/employee-detail',
  'SCR-BIZ-012': '/bulk-employee-import',
};

export const EMPLOYEE_READ_PERM = 'PERM-corporate.employee.read';
export const EMPLOYEE_INVITE_PERM = 'PERM-corporate.employee.invite';
export const EMPLOYEE_UPDATE_PERM = 'PERM-corporate.employee.update';
export const EMPLOYEE_REMOVE_PERM = 'PERM-corporate.employee.remove';

export const EMPLOYEES_PERMISSIONS: Partial<Record<EmployeesScreenId, readonly string[]>> = {
  'SCR-BIZ-009': [EMPLOYEE_READ_PERM],
  'SCR-BIZ-010': [EMPLOYEE_INVITE_PERM],
  'SCR-BIZ-011': [EMPLOYEE_UPDATE_PERM],
  'SCR-BIZ-012': [EMPLOYEE_INVITE_PERM],
};

export const EMPLOYEES_ENDPOINTS: Partial<Record<EmployeesScreenId, readonly string[]>> = {
  'SCR-BIZ-009': ['GET /business/v1/employees'],
  'SCR-BIZ-010': ['POST /business/v1/employees/invitations'],
  'SCR-BIZ-011': [
    'GET /business/v1/employees/{id}',
    'PATCH /business/v1/employees/{id}',
    'POST /business/v1/employees/{id}/suspend',
    'POST /business/v1/employees/{id}/reactivate',
    'DELETE /business/v1/employees/{id}',
    'GET /business/v1/employees/{id}/spend',
  ],
  'SCR-BIZ-012': [
    'POST /business/v1/employees/bulk-invitations',
    'GET /business/v1/employees/bulk-invitations/{jobId}',
    'GET /business/v1/employees',
  ],
};

export const ACCEPT_INVITE_SCREEN_ID = 'AUTH-ACCEPT-INVITE';
export const EMPLOYEE_ID_STORAGE_KEY = 'beatq.business.employeeId';
